import { Icon } from '@mirai-kids-monte/core/src/components/dataDisplay/Icon';
import { forwardRef } from 'react';
import styles from './index.module.scss';

type Props = {
  isOpenMenu: boolean;
  onChangeMenuOpen: (isOpen: boolean) => void;
  accentColor?: string;
  /** 開閉対象のメニューの id。aria-controls で関連づける */
  menuId?: string;
};

const HamburgerMenuButton = forwardRef<HTMLButtonElement, Props>(
  ({ isOpenMenu, onChangeMenuOpen, accentColor, menuId }, ref) => {
    const onClickMenuIcon = () => {
      onChangeMenuOpen(!isOpenMenu);
    };

    return (
      <div className={styles.base}>
        <button
          ref={ref}
          type="button"
          className={styles.icon}
          style={accentColor ? { backgroundColor: accentColor } : undefined}
          aria-label={isOpenMenu ? 'メニューを閉じる' : 'メニューを開く'}
          aria-expanded={isOpenMenu}
          // メニューは開いている間だけ DOM に存在するため、閉じているときは
          // 実在しない id を指さないよう aria-controls を出さない
          aria-controls={isOpenMenu ? menuId : undefined}
          onClick={onClickMenuIcon}
        >
          {isOpenMenu ? <Icon name="Close" size={30} /> : <Icon name="Menu" size={30} />}
        </button>
      </div>
    );
  }
);

HamburgerMenuButton.displayName = 'HamburgerMenuButton';

export default HamburgerMenuButton;
